exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.terms{padding:80px 0px 10px 15px}div.terms ol[type=\"1\"]{list-style-type:decimal}div.terms ol[type=a]{list-style-type:lower-alpha;margin-left:20px}div.terms ol[type=i]{list-style-type:lower-roman;margin-left:20px}div.terms strong,div.terms h5{font-weight:bold}.terms strong,.terms b{font-weight:bold}.terms li{display:list-item;padding-left:10px}.terms ul{list-style-type:circle;list-style-position:inside}.terms ol{display:block;list-style-type:decimal;list-style-position:inside}.terms p{padding:5px 0}.terms h4{text-align:center}", ""]);

// exports
